import React, {useCallback, useEffect, useLayoutEffect} from 'react';
import {isNullOrUndefined} from '../../shared';
import NewReport from './NewReport';
// import useSaveMarketingUserHook from './components/general-data/useSaveMarketingUserHook';
import {patentWithoutVerifier} from '../../shared/utils';
import {connect} from 'react-redux';
import {
    cancelNewReportAction,
    deleteBillInfoAction,
    disableIsDirty,
    generalDataIsDirtyAction,
    newReportPatchStateAction,
    newReportUpdateNestedPropAction,
    paymentSelectedIsDirtyAction,
    pushNewReport,
    updateBillInfoAction,
    updateGeneralDataAction,
    updatePaymentTypeAction
} from './store/new-report.actions';
import {resetStateAction, setGeneralDataErrors} from './store';
import eventBus from '../../service/eventBus';
import {fetchProfileAction} from '../../store/_auth/auth.actions';
import {AuthEvents} from '../../store/_auth/auth.events';
import {registerAnalyticsEvent} from 'shared/utils/analytics';
import {GaStepCancelLabel, Google_Analitys_Categories} from 'settings/data';


export const NewReportProvider = ({actions, user, profile, state, dispatch}) => {

    const {data, ui} = state;
    const userInfo = profile && {...profile, email: user?.email};
    // const saveMarketingUser = useSaveMarketingUserHook();
    const {cat_new_report, ga_actions} = Google_Analitys_Categories;

    const generalDataRef = React.useRef();

    const validateSelectedPayment = useCallback(() => {
        actions.paymentSelectedIsDirtyAction(true);
        registerAnalyticsEvent({category: cat_new_report, action: ga_actions.select_payment, label: data.paymentType});
        registerAnalyticsEvent({category: cat_new_report, action: ga_actions.next, label: 'go_to_summary_step'});
        return !isNullOrUndefined(data.paymentType);
    }, [actions, data.paymentType]);

    const dispatchGeneralData = useCallback(async (generalData) => {
        // const success = await saveMarketingUser(generalData);
        // if (success) {
        try {
            actions.updateGeneralDataAction(generalData);
            return true;
        } catch (e) {
        }

        // }
        return false;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [actions, data.patentes]);

    const validateGeneralData = useCallback(async () => {
        actions.generalDataIsDirtyAction(true);
        generalDataRef.current.handleSubmit();
        await generalDataRef.current.validateForm();
        actions.setGeneralDataErrors(generalDataRef.current.errors);

        if (generalDataRef.current.isValid) {
            actions.generalDataIsDirtyAction(false);
            registerAnalyticsEvent({
                category: cat_new_report,
                action: ga_actions.next,
                label: 'go_to_payment_method_step'
            });
            return await dispatchGeneralData(generalDataRef.current.values);
        }

        return false;
    }, [actions, dispatchGeneralData]);

    const onBackPaymentSelected = useCallback(() => {
        actions.disableIsDirty();
        actions.newReportUpdateNestedPropAction({path: 'data.generalData.recaptcha', undefined});
    }, [actions]);

    const onCancel = useCallback(async (step) => {
        registerAnalyticsEvent({
            category: cat_new_report,
            action: ga_actions.cancel,
            label: GaStepCancelLabel[step - 1],
        });

        generalDataRef.current.handleSubmit();
        actions.cancelNewReport(generalDataRef.current.values);
    }, [actions]);

    const onCreateNewReport = useCallback(async () => {
        registerAnalyticsEvent({category: cat_new_report, action: ga_actions.pay, label: 'create_new_report'});
        const payload = {
            'email': data.generalData.email,
            'rut': data.generalData.rut,
            'name_lastname': data.generalData.name,
            'phone': data.generalData.phone,
            'rut_billing': data.billInfo.rut,
            'social_reason': data.billInfo.businessType,
            'economic_activity': data.billInfo.economicActivity,
            'address': data.billInfo.address,
            'payment_type': data.paymentType,
            'patents': data.generalData.patentes
                .map(v => v.reportType
                    .map(type => ({
                            ppu: v.patente,
                            ppu_simplified: patentWithoutVerifier(v.patente),
                            type
                        })
                    )
                ).flat(2),
            'recaptcha': data.generalData.recaptcha
        };

        actions.pushNewReport(payload)
    }, [data]);

    // On first load flush Data from localStorage to redux cache
    // Fetch Profile Data
    useEffect(() => {
        if (!profile && user) return actions.fetchProfileAction(user);
    }, [profile]);

    useLayoutEffect(() => {
        const signOutEventListener = () => actions.resetStateAction();
        eventBus.on(AuthEvents.signOut, signOutEventListener);
        return () => {
            eventBus.remove(AuthEvents.signOut, signOutEventListener);
        };
    }, []);

    const actionsCreators = React.useMemo(
        () => ({
            validateSelectedPayment,
            validateGeneralData,
            onBackPaymentSelected,
            updatePaymentType: actions.updatePaymentTypeAction,
            updateBillInfo: actions.updateBillInfoAction,
            deleteBillInfo: actions.deleteBillInfoAction,
            updateGeneralData: actions.updateGeneralDataAction,
            acceptTermAndConditionsAction: actions.acceptTermAndConditionsAction,
            onCreateNewReport,
            onCancel,
            generalDataRef,
        }),
        [validateSelectedPayment, onBackPaymentSelected, actions, onCancel, onCreateNewReport, validateGeneralData],
    );

    return (
        <NewReport userInfo={userInfo} {...actionsCreators} state={state}/>
    );
};

const mapStateToProps = (state) => ({
    state: state.newReportReducers,
    user: state.authReducers.user,
    profile: state.authReducers.profile
});

const mapDispatchToProps = dispatch => {
    return {
        actions: {
            cancelNewReport: (generalData) => dispatch(cancelNewReportAction(generalData)),
            paymentSelectedIsDirtyAction: (payload) => dispatch(paymentSelectedIsDirtyAction(payload)),
            updateGeneralDataAction: (payload) => dispatch(updateGeneralDataAction(payload)),
            generalDataIsDirtyAction: (payload) => dispatch(generalDataIsDirtyAction(payload)),
            disableIsDirty: (payload) => dispatch(disableIsDirty(payload)),
            newReportUpdateNestedPropAction: (payload) => dispatch(newReportUpdateNestedPropAction(payload)),
            updatePaymentTypeAction: (payload) => dispatch(updatePaymentTypeAction(payload)),
            updateBillInfoAction: (payload) => dispatch(updateBillInfoAction(payload)),
            deleteBillInfoAction: (payload) => dispatch(deleteBillInfoAction(payload)),
            setGeneralDataErrors: (payload) => dispatch(setGeneralDataErrors(payload)),
            pushNewReport: (payload) => dispatch(pushNewReport(payload)),
            resetStateAction: (payload) => dispatch(resetStateAction(payload)),
            fetchProfileAction: (payload) => dispatch(fetchProfileAction(payload)),
            acceptTermAndConditionsAction: (payload) => dispatch(newReportPatchStateAction({acceptTermAndConditions: payload})),
        },
        dispatch
    }
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(NewReportProvider);
